import Script from 'next/script'
import { memo } from 'react'

interface IPropTypes {
  trackingId: string
}
function GoogleAnalytics({ trackingId = '' }: IPropTypes) {
  if (!trackingId) return null

  if (trackingId.toString().startsWith('G-')) {
    return (
      <>
        <Script
          strategy='afterInteractive'
          src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}`}
        />
        <Script
          id='gtag-init'
          strategy='afterInteractive'
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${trackingId.toString()}', {
              page_path: window.location.pathname,
            });
          `,
          }}
        />
      </>
    )
  }
  return (
    <Script
      id='gtag-init'
      strategy='afterInteractive'
      dangerouslySetInnerHTML={{
        __html: `
          (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
            
            ga('create', '${trackingId.toString()}', 'auto');
            ga('send', 'pageview');
          `,
      }}
    />
  )
}

export default memo(GoogleAnalytics)
